export const setUnauthorizedApp = (role) => {
  if (role && !role.find((r) => r === "PARTICULIER")) {
    return true;
  } else return false;
};
